import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input class={{concat \"input l-fill input-currency \" this._isInvalid this.inputClassNames}} placeholder={{this.placeholder}} disabled={{this.disabled}} />", {
  moduleName: "@dashboard/shared-ui/components/sq-input-currency.hbs"
});